import {
  LoginState,
  SET_CLEAN_USER,
  SET_ERROR_MESSAGE,
  SET_IS_ERROR,
  SET_LOADING_LOGIN,
  SET_USER,
  UserActionTypes,
} from './types';

const INITIAL_STATE: LoginState = {
  token: '',
  login: '',
  errorMessage: '',
  isError: false,
  signed: false,
  loading: false,
  password: '',
  name: '',
  avatar: '',
  permissoes: [],
};

const userReducer = (
  state = INITIAL_STATE,
  action: UserActionTypes,
) => {
  switch (action.type) {
    case SET_USER:
      return {
        ...state,
        id: action.payload.id,
        token: action.payload.token,
        login: action.payload.login,
        errorMessage: action.payload.errorMessage,
        isError: action.payload.isError,
        signed: action.payload.signed,
        password: action.payload.password,
        name: action.payload.name,
        avatar: action.payload.avatar,
        permissoes: action.payload.permissoes,
      };
    case SET_LOADING_LOGIN:
      return {
        ...state,
        loading: action.payload,
      };
    case SET_ERROR_MESSAGE:
      return {
        ...state,
        errorMessage: action.payload,
        isError: true,
      };
    case SET_IS_ERROR:
      return {
        ...state,
        loading: false,
        isError: action.payload,
      };
    case SET_CLEAN_USER:
      return {
        ...state,
        token: '',
        login: '',
        errorMessage: '',
        isError: false,
        signed: false,
        loading: false,
        password: '',
        name: '',
        avatar: '',
        permissoes: [],
      };
    default:
      return state;
  }
};
export default userReducer;
